<div
  class="app-loader"
  [class.app-loader--centered]="centered"
  role="status"
  aria-live="polite"
>
  <svg
    class="app-loader__spinner"
    [style.width.px]="size"
    [style.height.px]="size"
    viewBox="0 0 64 64"
    aria-hidden="true"
  >
    <circle
      class="app-loader__path"
      cx="32"
      cy="32"
      r="28"
      fill="none"
      stroke-width="5"
      stroke-miterlimit="10"
      stroke-linecap="round"
    ></circle>
  </svg>
  @if (label) {
    <span class="app-loader__label">{{ label }}</span>
  }
</div>
